import * as React from 'react'
import styles from './header.page.styl'
import cx from 'classnames'
import LastUpdate from '@src/components/common/last.update'
import type { DateInput } from '@src/utils/date.helpers'
import { CSSSelector } from '@src/utils/css.selector.helper'

export interface Props {
  lastUpdate?: DateInput
  id?: string
  className?: string
}

const HeaderPageCSSSelectors = {
  title: new CSSSelector('titlePage')
}

const HeaderPage: React.FC<React.PropsWithChildren<Props>> = React.memo(
  (props: React.PropsWithChildren<Props>) => {
    const { lastUpdate, id, children, className } = props
    return (
      <div id={id} className={cx(styles.headerPage, className)}>
        <div
          className={cx(
            HeaderPageCSSSelectors.title.value,
            styles.titleContainer
          )}
        >
          {children}
        </div>
        <LastUpdate className={styles.lastUpdate} lastUpdate={lastUpdate} />
      </div>
    )
  }
)

export default HeaderPage
